var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time)?_c('div',{staticClass:"meta"},[_c('span',{staticClass:"floated time"},[_c('i',{staticClass:"clock outline icon",staticStyle:{"margin-left":"-2px"}}),_vm._v(" "+_vm._s(_vm.time)+" Uhr ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }